<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-group mb-4">
          <div class="card p-4">
            <div class="card-body" [formGroup]="loginForm">
              <h1>Login</h1>
              <p class="text-muted">Entre em sua conta</p>

              <div class="alert alert-danger" *ngIf="errors.length > 0">
                <h3 id="msgRetorno">Opa! Alguma coisa não deu certo:</h3>
                <ul>
                  <li *ngFor="let error of errors">{{ error }}</li>
                </ul>
              </div>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-user"></i>
                  </span>
                </div>
                <input type="text" class="form-control" placeholder="e-mail" formControlName="email">
              </div>
              <div>
                <span class="text-danger" *ngIf="displayMessage.email">
                  <p [innerHTML]="displayMessage.email"></p>
                </span>
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-key"></i>
                  </span>
                </div>
                <input type="password" id="password" class="form-control" placeholder="senha" formControlName="password"
                  required>
              </div>
              <div>
                <span class="text-danger" *ngIf="displayMessage.password">
                  <p [innerHTML]="displayMessage.password"></p>
                </span>
              </div>

              <div *ngIf="recuperarSenhaOn">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-check-double"></i>
                    </span>
                  </div>
                  <input type="password" id="confirmPassword" class="form-control" placeholder="confirmar a senha"
                    formControlName="confirmPassword">
                </div>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-shield-alt"></i>
                    </span>
                  </div>
                  <input type="text" class="form-control" placeholder="código recebido" formControlName="code">
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-primary px-4" (click)="onSubmit()">OK</button>
                </div>
                <div class="col-6 text-right">
                  <button type="button" class="btn btn-link px-0" (click)="esqueciMinhaSenha()">Esqueceu sua
                    senha?</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card bg-secundary py-5 d-md-down-none" style="width:44%">
            <div class="card-body text-center">
              <div class="">
                <img src="assets\img\home\logo.png" alt="Madu Logo" style="width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>